import type { PointGetCardsFilters } from '@vlabs/api/types';
import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

const [
  useCardsFilters,
  CardsFiltersProvider,
] = createGenericFiltersContext<PointGetCardsFilters>({
  displayName: 'CardsFilters',
});

export {
  useCardsFilters,
  CardsFiltersProvider,
};
